<template>
  <v-dialog :value="value" width="75%" @click:outside="onClose">
    <v-card>
      <v-card-title>{{label("description")}}</v-card-title>
      <div class="d-flex flex-row flex-wrap" style="max-height: calc(90vh - 128px); overflow-y: auto;">
        <div class="d-flex flex-column align-center">
          <FileSelectButton
              image
              width="320px"
              height="180px"
              :max-size="10 * 1024 * 1024"
              class="ma-2"
              @input="onInputImageFile"
              @error="onErrorImageFile"
          >
            {{label('uploadImage')}}
            <br/><br/>
            {{label('uploadImageHint')}}
          </FileSelectButton>
          <div
              v-if="imageUploadErrorMessage"
              class="caption red--text"
          >
            {{imageUploadErrorMessage}}
          </div>
          <Dialog :open="image != null" @close="image = null">
            <ImageEditor
                ref="editor"
                :src="image"
                :image-width="320 * 4"
                :image-height="180 * 4"
            />
            <template #actions>
              <ActionButton
                  :disabled="image == null"
                  @click="onUpload"
              >
                {{label("upload")}}
              </ActionButton>
            </template>
          </Dialog>
        </div>
        <v-img
            v-for="image in images"
            :key="image.id"
            :src="image.url"
            max-width="320px"
            max-height="180px"
            class="ma-2"
            @click="onSelectImage(image)"
        >
          <v-icon
              v-if="selected(image)"
              class="selectedImage ma-1"
          >
            mdi-check-circle
          </v-icon>
        </v-img>
      </div>
      <v-card-actions>
        <v-spacer/>
        <ActionButton
            type="submit"
            width="240px"
            @click="onSubmit"
        >
          {{label("select")}}
        </ActionButton>
        <ActionButton
            type="cancel"
            width="240px"
            @click="onClose"
        >
          {{label("cancel")}}
        </ActionButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";
import ActionButton from "@/components/molecules/ActionButton";
import ApiMixin from "@/ApiMixin";
import FileSelectButton from "@/components/atoms/FileSelectButton";
import Dialog from "../atoms/Dialog";
import ImageEditor from "../atoms/ImageEditor";

export default {
  components: {ImageEditor, Dialog, FileSelectButton, ActionButton},
  mixins: [ComponentMixin, ApiMixin],
  type: "organism",
  name: "ClientImageSelectDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    imageId: {
      type: String,
    }
  },
  data () {
    return {
      image: null,
      selectedImageId: this.imageId,
      imageUploadErrorMessage: null
    }
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("client", ["images"]),
    selected() {
      return (image) => {
        return image.id === this.selectedImageId;
      }
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onInputImageFile(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    onUpload() {
      const editor = this.$refs.editor
      const image = editor.getImage()
      if (image != null) {
        const file = this.convertToFile(image)
        this.uploadImage(file).then(() => {
          this.image = null;
        })
      }
    },
    onErrorImageFile(file, message) {
      this.imageUploadErrorMessage = message;
    },
    onSelectImage(image) {
      this.selectedImageId = image.id;
    },
    onSubmit() {
      this.$emit("select", this.images.find(image => image.id === this.selectedImageId));
    },
    convertToFile(data) {
      const blob = atob(data.replace(/^.*,/, ''))
      const buffer = new Uint8Array(blob.length)
      for (let index = 0; index < blob.length; index++) {
        buffer[index] = blob.charCodeAt(index)
      }
      return new File([buffer.buffer], 'user_image', { type: 'image/png' })
    },
  },
  watch: {
    value: {
      handler: function(value) {
        if (value) {
          this.selectedImageId = null;
        }
      }
    },
    "user.id": {
      handler: function(value) {
        if (value) {
          this.loadImages();
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="sass">
.selectedImage
  color: #E68019
  font-size: 32px
  border-radius: 50%
  background-color: white

</style>
